<template>
  <header
    id="header"
    :class="{ 'expanded': !sidebarExpanded }"
  >
    <div class="header-container p-3">
      <div class="d-flex align-items-center mr-auto">
        <a
          class="icon d-lg-none"
          @click.prevent.stop="toggleSidebar"
        >
          <fa-icon icon="bars" size="lg" />
        </a>
        <h5 class="mt-2"><b>{{ title }}</b></h5>
      </div>

      <b-dropdown
        menu-class="shadow"
        variant="link"
        toggle-class="text-decoration-none"
        boundary="#header"
        no-caret
        right
      >
        <template #button-content>
          <div class="profile">
            <img
              class="rounded-circle mr-2"
              src="@/assets/icon-profile.png"
              alt="logo"
              width="45"
              height="45"
            >
            <div class="box">
              <span id="name"><b>{{ fullname }}</b></span>
              <span id="role" class="text-muted">{{ role }}</span>
              <span v-if="profile.roles.name !== 'Administrator'" id="role" class="text-muted">{{ description }}</span>
            </div>
          </div>
        </template>
        <b-dropdown-item @click="logout">Logout</b-dropdown-item>
      </b-dropdown>
    </div>

    <hr>
  </header>
</template>

<script>
export default {
  props: {
    sidebarExpanded: {
      type: Boolean,
      default: false
    }
  },

  data: () => ({
    profile: JSON.parse(localStorage.getItem('profile'))
  }),

  computed: {
    title() {
      return this.$route.name
    },
    fullname() {
      return this.profile.fullname
    },
    role() {
      return this.profile.roles.name
    },
    description() {
      if (this.profile.contractors) {
        return this.profile.contractors.name
      } else {
        const dept = this.profile.departments ? `dept. ${this.profile.departments.code}, ` : ''
        const div = this.profile.division ? `div. ${this.profile.division.code}, ` : ''
        const comp = this.profile.company ? `comp. ${this.profile.company.code}` : ''
        return dept + div + comp
      }
    }
  },

  methods: {
    toggleSidebar() {
      this.$emit('toggle-sidebar')
    },
    logout() {
      localStorage.clear()
      this.$router.replace('/login')
    }
  }
}
</script>

<style lang="scss" scoped>
header {
  align-items: center;
  left: 0;
  position: fixed;
  right: 0;
  top: 0;
  z-index: 101;
  background-color: #fff;
  border-top-left-radius: 32px;
  border-top-right-radius: 32px;
  margin: 12px 12px 0 12px;
  transition: 0.3s;

  @media screen and (min-width: 992px) {
    margin-left: 230px;

    &.expanded {
      margin-left: 80px;
    }
  }
}

h5 {
  @media screen and (min-width: 992px) {
    margin-left: 1rem;
  }
}

.profile {
  align-items: center;
  display: flex;
  justify-content: flex-end;
  height: 45px;

  .box {
    display: grid;
    align-content: center;

    #name {
      font-size: 14px;
    }

    #role {
      font-size: 11px;
    }
  }
}

.icon {
  color: inherit;
  padding: 10px 15px;
}

hr {
  border: 1px dashed rgb(218, 214, 214);
  margin: 0 20px 20px 20px;
}

.dropdown {
  width: auto;
}

.header-container {
  display: flex;
  @media screen and (max-width: 400px) {
    display: grid;
  }
}
</style>
